export const ROOT_INDEX = '/';
export const LOGIN_INDEX = '/login';
export const SSO_INDEX = '/sso';
export const SUPPORT_LOGIN_INDEX = '/support_login';
export const FORGOT_PASSWORD_INDEX = '/forgot_password';
export const RESET_PASSWORD_INDEX = '/reset_password';
export const DEFAULT_REDIRECT_AFTER_LOGIN = '/app/#/';
